export const OKQ8_FUEL_COMPANY_ID = 1;

export function isOkq8FuelCompany(id?: number | null, name?: string | null): boolean {
  if (Number(id) === OKQ8_FUEL_COMPANY_ID) return true;
  const n = String(name ?? '').trim().toLowerCase();
  return n.includes('okq8');
}

export function looksLikeOkq8EmbossedNumber(value: string | null | undefined): boolean {
  return /^[0-9]{16}$/.test(String(value ?? '').replace(/\s+/g, ''));
}
